import React from 'react';
import styles from './styles.module.scss';

interface ProgressBarProps {
  progress?: number;
  step?: number;
  total?: number;
  label?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ step = 0, total = 0 }) => {
  const count = total > 0 ? total : 1;
  const active = Math.min(Math.max(step, 0), count - 1);
  const current = active + 1;

  return (
    <div
      className={styles.progressWrap}
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={count}
      aria-valuenow={current}
      aria-label={`Passo ${current} di ${count}`}
    >
      <div className={styles.segments}>
        {Array.from({ length: count }, (_, index) => (
          <span
            key={index}
            className={index <= active ? styles.segmentOn : styles.segment}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
